// @flow

import { type IncomingPayment } from './types';

export function getPaymentTypeCode(incomingPayment: IncomingPayment): ?string {
  return incomingPayment['payment_type_code'];
}

export function getSafePaymentTypeCode(incomingPayment: IncomingPayment): string {
  const paymentTypeCode = getPaymentTypeCode(incomingPayment);

  if (!paymentTypeCode)
    throw new Error('getPaymentTypeCode - there is no payment type code in incoming payment');

  return paymentTypeCode;
}
